import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Lock } from '../../models/lock';
import { LockService } from '../../services/lock.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-locks-delete',
  templateUrl: './locks-delete.component.html',
  styleUrls: ['./locks-delete.component.css']
})
export class LocksDeleteComponent implements OnInit {
  lock : Lock;
  @Output() onDeleteValidation = new EventEmitter<boolean>();

  constructor(public lockService : LockService,
              public activeModal : NgbActiveModal,
              public toast : ToastsManager,
              public translate : TranslateService) { }

  ngOnInit() {
  }

  onDeleteClick() {
    this.lockService.delete(this.lock).subscribe(() => {
      this.activeModal.close("close");
      this.toast.success(this.translate.instant("toast.lockdeleted"), this.translate.instant("toast.success"));
      this.onDeleteValidation.emit(true);
    });

    this.activeModal.close();
    
  }

}



// WEBPACK FOOTER //
// ./src/app/locks/locks-delete/locks-delete.component.ts